<template>
    <div>
        <r-input
            left-icon="search"
            :right-icon="closeIcon"
            right-icon-click-pointer
            @right-icon-click="clearSearch"
            placeholder="Search segments"
            v-model="searchQuery"/>
    </div>
</template>

<script>
    import isBlank from '@/common/helpers/is-blank';
    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: 'segment-search',
        computed: {
            ...mapGetters({
                segmentCollection: 'segments/segmentCollection',
            }),
            searchQuery: {
                get() {
                    return this.segmentCollection.activeCategory.searchQuery;
                },
                set(value) {
                    this.updateSegmentsSearchQuery(value);
                },
            },
            closeIcon() {
                return !isBlank(this.searchQuery) ? 'close-s' : null;
            },
        },
        methods: {
            ...mapActions({
                updateSegmentsSearchQuery: 'segments/updateSearchQuery',
            }),
            clearSearch() {
                this.updateSegmentsSearchQuery(null);
            },
        },
    };
</script>
